import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import BulkVehicleAssignmentUpload from '../components/rider/BulkVehicleAssignmentUpload';

const BulkVehicleAssignmentImport: React.FC = () => {
  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" fontWeight={700}>
          Bulk Vehicle Assignment Import
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Upload an Excel file and submit bulk vehicle assignment requests using the same workflow as the single admin assignment route.
        </Typography>
      </Box>

      <BulkVehicleAssignmentUpload />
    </Container>
  );
};

export default BulkVehicleAssignmentImport;
